import { sendHttp } from '../assets/js/request'

const visualDataApi = {
  // 获取大屏数据
  getMonitorData (params) {
    return sendHttp('get', '/intelligence/monitor', params)
  },
  // 获取统计维度
  getStatisticsType (params) {
    return sendHttp('get', '/intelligence/monitor/statisticsType', params)
  },
  // 获取统计数据
  getStatistics (params) {
    return sendHttp('get', '/intelligence/monitor/statistics', params)
  },
  // 获取血糖分布
  getGluStatistics (params) {
    return sendHttp('get', '/intelligence/monitor/gluStatistics', params)
  },
  // 获取最近血糖列表
  getLatestGluList (params) {
    return sendHttp('get', '/intelligence/monitor/latestGluList', params)
  },
  // 获取血糖监测统计
  getGluMonitorList (params) {
    return sendHttp('get', '/intelligence/monitor/gluMonitorList', params)
  },
  // 获取糖尿病类型患者分布
  getGluTypeStatistics (params) {
    return sendHttp('get', '/intelligence/monitor/gluTypeStatistics', params)
  },
  // 获取患者分布
  getPatientStatistics (params) {
    return sendHttp('get', '/intelligence/monitor/patientStatistics', params)
  },
  // 获取长期未测统计
  getUnmeasuredList (params) {
    return sendHttp('get', '/intelligence/monitor/unmeasuredList', params)
  },
  // 获取糖危急血糖报警
  getCrisisGluList (params) {
    return sendHttp('get', '/intelligence/monitor/crisisGluList', params)
  }
}

export {visualDataApi}



// WEBPACK FOOTER //
// ./src/apis/visualDataApi.js